// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3EQqr","selects":"Documents_selects__2h-BL"};